
<style scoped>
   .el-container{
     position: absolute;
     top:0;
     left:0;
     bottom:0;
     right: 0;
     display: flex;
     display: -webkit-flex;
     align-items: center;
     -webkit-align-items: center;
     justify-content: center;
     -webkit-justify-content: center;
     background-color: white;
   }
   .button-width {
       width: 100%;
   }
</style>

<template>
     <el-container>
         <el-tabs v-model="activeName" >
             <el-tab-pane label="登录" name="signIn">
                <el-form :model="ruleLogin" status-icon :rules="loginRules" ref="ruleLogin" class="demo-ruleForm">
                    <el-form-item prop="accountName">
                        <el-input type="text" v-model="ruleLogin.accountName" auto-complete="off" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" v-model="ruleLogin.password" auto-complete="off" placeholder="请输入密码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="button-width" type="primary" size="medium" @click="subimtLogin('ruleLogin')">登录</el-button>
                    </el-form-item>
                </el-form>
             </el-tab-pane>
             <!-- <el-tab-pane label="注册" name="signUp">
                <el-form :model="ruleSignUp" status-icon :rules="signUpRules" ref="ruleSignUp" class="demo-ruleForm">
                    <el-form-item prop="accountName">
                        <el-input type="password" v-model="ruleSignUp.accountName" auto-complete="off" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" v-model="ruleSignUp.password" auto-complete="off" placeholder="请输入密码"></el-input>
                    </el-form-item>
                    <el-form-item prop="confirmPassword">
                        <el-input type="password" v-model="ruleSignUp.confirmPassword" auto-complete="off" placeholder="请再次输入密码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="button-width" type="primary" @click="subimtSignUp('ruleSignUp')">注册</el-button>
                    </el-form-item>
                </el-form>
             </el-tab-pane> -->
         </el-tabs>
         
     </el-container>
</template>

<script>
import app from '@/App.vue';
import {apiSignIn, apiSignUp} from '@/request/api';

export default {
    data() {
        var checkName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('用户名不能为空'));
            }
            callback();
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            }
            callback();
        };
        var confirmPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } 
            if (this.ruleSignUp.password != this.ruleSignUp.confirmPassword) {
                callback(new Error('您输入的密码不一致'));
            }
            callback();
        };
        return {
            activeName: 'signIn',
            ruleLogin: {
                accountName: '',
                password: ''
            },
            loginRules: {
                accountName: [
                    { validator: checkName, trigger: 'blur'}
                ],
                password: [
                    { validator: validatePass, trigger: 'blur'}
                ]
            },
            ruleSignUp: {
                accountName: '',
                password: '',
                confirmPassword: ''
            },
            signUpRules: {
                accountName: [
                    { validator: checkName, trigger: 'blur'}
                ],
                password: [
                    { validator: validatePass, trigger: 'blur'}
                ],
                confirmPassword: [
                    { validator: confirmPass, trigger: 'blur'}
                ]
            }
        };
    },
    methods: {
        subimtLogin(formName) {
            
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    apiSignIn({
                        accountName: this.ruleLogin.accountName,
                        password: this.ruleLogin.password
                    }).then(res => {
                        var status = res.status;
                        var msg = res.msg;
                        if (status === '2') {
                            this.$message.error(msg);
                        } else {
                            var data = res.data;
                            if (data != null) {
                                app.globalData.userInfo = data;
                            }

                            //保存用户登录态
                            sessionStorage.setItem("userInfo", JSON.stringify(data));
                            this.$refs['ruleLogin'].resetFields();
                        
                            this.$router.push("/Layout").catch(error => error);
                        }
                        
                    })


                } else {
                    console.log('error');
                    return false;
                }
            })
        },
        subimtSignUp(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    apiSignUp({
                        accountName: this.ruleSignUp.accountName,
                        password: this.ruleSignUp.password
                    }).then(res => {
                        var status = res.status;
                        var msg = res.msg;
                        if (status === '2') {
                            this.$message.error(msg);
                        } else {
                            this.$message.success("注册成功");
                        }
                    })


                } else {
                    console.log('error');
                    return false;
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/signIn.vue